var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40039 5.82037C2.40039 5.25727 2.85688 4.80078 3.41998 4.80078H15.6551C16.2182 4.80078 16.6747 5.25727 16.6747 5.82037V9.61288L21.9223 5.86458C22.2597 5.62356 22.7284 5.86476 22.7284 6.27941V16.0968C22.7284 16.5115 22.2597 16.7527 21.9223 16.5117L16.6747 12.7634V17.0359C16.6747 17.599 16.2182 18.0555 15.6551 18.0555H3.41998C2.85688 18.0555 2.40039 17.599 2.40039 17.0359V5.82037ZM4.43957 6.83996H14.6355V16.0163H4.43957V6.83996ZM21.0291 13.7854L17.3929 11.1881L21.0291 8.59088V13.7854Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCam);
export default __webpack_public_path__ + "static/media/icon-cam.5a00427e47e06706516e86da9de64b13.svg";
export { ForwardRef as ReactComponent };